import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ProviderSidebarComponent } from '../sidebar/provider-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PickupThingsComponent } from '../../shared/components/pickup-things/pickup-things.component';
import { ActivitiesComponent } from '../../shared/components/activities/activities.component';
import { RolesApiService, Role } from '@angular-workspace/services';
import { ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'app-provider-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    ProviderSidebarComponent,
    PageHeaderComponent,
    PickupThingsComponent,
    ActivitiesComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class ProviderDashboardComponent implements OnInit {
  private router = inject(Router);
  private rolesService = inject(RolesApiService);
  private toasterService = inject(ToasterService);

  async ngOnInit(): Promise<void> {
    // Check if user should be redirected to their highest role panel
    try {
      await this.rolesService.getRoles();
      const userRoles = this.rolesService.getUserRoles();

      if (userRoles && userRoles.length > 0) {
        // Get the highest role panel route
        const highestRolePanelRoute = this.rolesService.getHighestRolePanelRoute(userRoles);
        
        // If the highest role panel is not provider, redirect to it
        if (highestRolePanelRoute !== '/provider/home' && highestRolePanelRoute !== '/provider/dashboard') {
          // User has a higher role than provider, redirect to their highest role panel
          console.log('User has higher role, redirecting from provider panel to:', highestRolePanelRoute);
          this.router.navigate([highestRolePanelRoute]);
          return;
        }
        
        // Check if user has provider role (for users who only have provider role)
        const hasProviderRole = userRoles.some(role => role.toLowerCase() === Role.PROVIDER.toLowerCase());
        
        if (!hasProviderRole) {
          // User doesn't have provider role, redirect to their highest role panel
          this.toasterService.warning("You don't have permission to access the Provider panel.");
          this.router.navigate([highestRolePanelRoute]);
        }
      }
    } catch (error) {
      console.error('Error checking roles:', error);
      // On error, allow access (development mode)
    }
  }
}


